import { render, staticRenderFns } from "./irpf.vue?vue&type=template&id=0d00d07e"
import script from "./irpf.vue?vue&type=script&lang=js"
export * from "./irpf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports